import React, {useContext, useEffect, useState} from 'react'
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import {api} from '../../../services/Main/Api'
import {
  Backdrop,
  Box,
  Card,
  CardContent,
  Container, Skeleton, useMediaQuery,
} from '@mui/material'
import {getCondoId, getCondoType} from '../../../services/Main/AuthStorage'
import InternalNotesCard from '../../../components/Shared/InternalNotesCard'
import {Helmet} from 'react-helmet'
import {useSnackbar} from "notistack";
import InvoiceDetailsButtons from "./components/InvoiceDetail/InvoiceDetailsButtons";
import InvoiceDetailHeader from "./components/InvoiceDetail/InvoiceDetailHeader/InvoiceDetailHeader";
import InvoiceDetailBody from "./components/InvoiceDetail/InvoiceDetailBody/InvoiceDetailBody";
import InvoiceDetailTable from "./components/InvoiceDetail/InvoiceDetailTable/InvoiceDetailTable";
import InvoiceDetailed from "./components/InvoiceDetail/InvoiceDetailed.";
import SimpleButtons from "../../../components/Shared/SimpleButtons";
import AnimationGlobal from "../../../components/Shared/animations/AnimationGlobal";
import loadingAnimation from '../../../assets/animations/loading.json'
import SimpleDialog from "../../../components/Shared/SimpleDialog";
import Context from "../../../contexts/Context";
import CircularProgress from "@mui/material/CircularProgress";
import ActivityLog from "../ActivityLog/ActivityLog";
import InvoiceBoletosTable from "./components/InvoiceDetail/InvoiceBoletosTable";
import InvoicePixTable from "./components/InvoiceDetail/InvoicePixTable";
import DeleteFeeDialog from "./components/InvoiceDetail/DeleteFeeDialog";
import AddFeeDialog from "./components/InvoiceDetail/AddFeeDialog";

const InvoiceDetail = (handleManualPayment) => {
  const { filters, setFilters, loadingModal, setLoadingModal, invoiceListRefresh, setInvoiceListRefresh } = useContext(Context)
  const params = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [invoice, setInvoice] = useState()
  const [condo, setCondo] = useState()
  const [routeId, setRouteId] = useState('')
  const [sending,  setSending] = useState(false)
  const [deleteFeeDialog, setDeleteFeeDialog] = useState({ open: false, feeId: null, feeName: '' })
  const [addFeeDialog, setAddFeeDialog] = useState(false)

  const sizeMatch = useMediaQuery('@media (min-width:600px)')

  const navigate = useNavigate()
  const {enqueueSnackbar} = useSnackbar()
  const {user} = useContext(Context)

  useEffect(() => {
    setIsLoading(true)
    getInvoiceId()
    //getCondo()
    window.scrollTo(0, 0)

    setTimeout(() =>{
    setIsLoading(false)
    }, 1000)
  }, [params?.id])

  const getInvoiceId = async () => {
        const url = `invoice/${!filters?.invoiceId ? params.id : filters?.invoiceId}/`
        let result = await api.get(url)
        result = await result.data
        setInvoice(result)
        setCondo(result?.condo)
        setInvoiceListRefresh(false)
  }

  const getCondo = async () => {
    const condo_id = getCondoId()
    const url = `condo/${condo_id}/`
    let result = await api.get(url)
    result = await result.data

    setCondo(result)
  }

  useEffect(function changeRoute(){
    if (routeId){
    navigate(`/faturas/${routeId}`)
    }
  }, [routeId])

  useEffect(() => {
    if (invoiceListRefresh === true) {
      getInvoiceId();
    }
  }, [invoiceListRefresh]);



  const sendToMail = () => {
    setSending(true)
    setLoadingModal(true)
    api.post(`/bank-slip/invoice/${invoice?.id}/send-mail/`)
      .then(r => {
        enqueueSnackbar(r.data.success, {variant: "success"})
      })
      .catch(error => {
        console.log(error)
        enqueueSnackbar('Erro ao Enviar Para o E-mail', {variant: "error"})
      }).finally(() =>{
        setSending(false)
        setLoadingModal(false)
    })

  }

  const canEditFees = (inv) => {
    if (getCondoType() !== 'RENT') return false
    if (inv?.status?.key !== 'open') return false
    if (!inv?.due_date) return false
    const now = new Date()
    const dueDate = new Date(inv.due_date)
    // Somente faturas de meses passados
    return (dueDate.getFullYear() < now.getFullYear()) ||
      (dueDate.getFullYear() === now.getFullYear() && dueDate.getMonth() < now.getMonth())
  }

  const handleDeleteFee = async (reason) => {
    try {
      setLoadingModal(true)
      await api.delete(`invoice-fee/${deleteFeeDialog.feeId}/`, { data: { reason } })
      enqueueSnackbar('Item excluído com sucesso', { variant: 'success' })
      setDeleteFeeDialog({ open: false, feeId: null, feeName: '' })
      getInvoiceId()
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.error || 'Erro ao excluir item', { variant: 'error' })
    } finally {
      setLoadingModal(false)
    }
  }

  const handleAddFee = async ({ description, total, category }) => {
    try {
      setLoadingModal(true)
      await api.post(`invoice/${invoice?.id}/add-fee/`, { description, total, category })
      enqueueSnackbar('Item adicionado com sucesso', { variant: 'success' })
      setAddFeeDialog(false)
      getInvoiceId()
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.error || 'Erro ao adicionar item', { variant: 'error' })
    } finally {
      setLoadingModal(false)
    }
  }

  const openDeleteFeeDialog = (feeId, feeName) => {
    setDeleteFeeDialog({ open: true, feeId, feeName })
  }

  return (
    <>
      {!filters?.modalInvoice ?
      <>
      <Helmet>
        <title>Detalhes da Fatura - Bloco B3</title>
      </Helmet>
        <Backdrop
          sx={{ color: '#fff', zIndex: 1500, }}
          open={loadingModal}
        >
          <CircularProgress color="inherit"/>
        </Backdrop>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >

        <Box
          sx={{
            display: 'grid',
            justifySelf: 'center',
            alignItems: 'center',
            width: sizeMatch ? '100%' : 'auto',
            marginX: sizeMatch ?  '2rem' : '0.5rem'

          }}
        >
        {/*{!isLoading &&*/}
          <Card
            sx={{
              width: '100%',
              // minWidth: '400px'
            }}

          >
          { !isLoading ?
          <CardContent>
              <>
                <InvoiceDetailHeader
                  invoice={invoice}
                  condo={condo}
                  sending={sending}
                  handleManualPayment={handleManualPayment}
                  sendToMail={sendToMail}
                />
                <InvoiceDetailBody
                  condo={condo}
                  invoice={invoice}
                />
                {sizeMatch ?
                  <Box
                  >
                    <InvoiceDetailTable
                      invoice={invoice}
                      canDelete={canEditFees(invoice)}
                      onDeleteFee={openDeleteFeeDialog}
                      onAddFee={() => setAddFeeDialog(true)}
                    />
                  </Box>
                  :
                  <InvoiceDetailed
                    invoice={invoice}
                    canDelete={canEditFees(invoice)}
                    onDeleteFee={openDeleteFeeDialog}
                    onAddFee={() => setAddFeeDialog(true)}
                  />
                }
              </>
          </CardContent>

          :
            <Skeleton
              variant="rounded"
              height={500}
              animation="pulse"
            />
          }

          </Card>

            { user?.is_superuser && <InvoiceBoletosTable invoiceId={invoice?.id} invoice={invoice} /> }
            { user?.is_superuser && <InvoicePixTable invoiceId={invoice?.id} invoice={invoice} /> }

          <InternalNotesCard state={invoice?.internal_notes}/>

          { user?.is_superuser && <ActivityLog activities={invoice?.activities}  /> }

        </Box>
      </Box>
      </>
        : filters?.modalInvoice &&
      <SimpleDialog
        open={filters?.modalInvoice}
        removeConfirm
        onClickCancel={() => {
          setFilters(prevState => ({...prevState, modalInvoice: false}))
        }}
        cancelText={'Fechar'}
        dialogContent={
          <>
              {!isLoading ?
                <>
                  <InvoiceDetailHeader
                    invoice={invoice}
                    sending={sending}
                    sendToMail={sendToMail}
                  />
                  <InvoiceDetailBody
                    condo={condo}
                    invoice={invoice}
                  />
                  {sizeMatch ?
                    <Box
                    >
                      <InvoiceDetailTable
                        invoice={invoice}
                        canDelete={canEditFees(invoice)}
                        onDeleteFee={openDeleteFeeDialog}
                      />
                    </Box>
                    :
                    <InvoiceDetailed
                      invoice={invoice}
                      canDelete={canEditFees(invoice)}
                      onDeleteFee={openDeleteFeeDialog}
                    />
                  }
                </>
                :
                <Skeleton
                  variant="rounded"
                  height={500}
                  animation="pulse"
                  sx={{
                    mb: '1.5rem'
                  }}
                />
              }
          </>
        }

      />
      }
      <DeleteFeeDialog
        open={deleteFeeDialog.open}
        feeName={deleteFeeDialog.feeName}
        onClose={() => setDeleteFeeDialog({ open: false, feeId: null, feeName: '' })}
        onConfirm={handleDeleteFee}
      />
      <AddFeeDialog
        open={addFeeDialog}
        onClose={() => setAddFeeDialog(false)}
        onConfirm={handleAddFee}
      />
    </>
  )
}

export default InvoiceDetail
